import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import { useTranslation } from 'react-i18next';

import { SidebarTypes } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';
import { AdminRoutePath } from 'applications/GSP/shared/constants/router';
import { useHideSchoolLinks } from 'applications/GSP/shared/hooks/user';

import type { NavigationItem } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

// TODO: think about implementation of more common solution
export const useAdminSchoolLinksNavigationItems = (): NavigationItem[] => {
  const { t } = useTranslation();
  const hideSchoolLinks = useHideSchoolLinks();

  return hideSchoolLinks
    ? []
    : [
        {
          label: t('GSP.layouts.mainLayout.sidebar.adminSchoolLinks'),
          icon: <FilePresentOutlinedIcon />,
          to: AdminRoutePath.AdminSchoolLinks,
          sidebarType: SidebarTypes.ADMIN,
        },
      ];
};
